import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Suspense, useState, useEffect } from 'react'
import Experience from './Experience.jsx'

// Loader component
function Loader({ onLoaded }) {
    const [progress, setProgress] = useState(0)
    const [isComplete, setIsComplete] = useState(false)
    const [fadeOut, setFadeOut] = useState(false)

    useEffect(() => {
        // Progress animation
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 99) {
                    clearInterval(interval)
                    // Wait 1 second at 99%
                    setTimeout(() => {
                        setProgress(100)
                        setTimeout(() => {
                            setFadeOut(true)
                            setTimeout(() => {
                                setIsComplete(true)
                                onLoaded()
                            }, 600)
                        }, 300)
                    }, 1000)
                    return 99
                }
                return prev + Math.random() * 15
            })
        }, 100)

        return () => clearInterval(interval)
    }, [])

    if (isComplete) return null

    return (
        <div className={`loader-container ${fadeOut ? 'fade-out' : ''}`}>
            {/* Background blobs */}
            <div className="loader-blob blob-1"></div>
            <div className="loader-blob blob-2"></div>
            <div className="loader-blob blob-3"></div>

            <div className="loader-content">
                {/* Logo / Title */}
                <div className="loader-title">
                    <span className="title-char">L</span>
                    <span className="title-char">o</span>
                    <span className="title-char">a</span>
                    <span className="title-char">d</span>
                    <span className="title-char">i</span>
                    <span className="title-char">n</span>
                    <span className="title-char">g</span>
                    <span className="title-char">.</span>
                    <span className="title-char">.</span>
                    <span className="title-char">.</span>
                </div>

                {/* Progress bar */}
                <div className="loader-progress-container">
                    <div className="loader-progress-bar">
                        <div
                            className="loader-progress-fill"
                            style={{ width: `${Math.min(progress, 100)}%` }}
                        ></div>
                    </div>
                    <div className="loader-progress-text">
                        {Math.min(Math.round(progress), 100)}%
                    </div>
                </div>

                {/* Loading text */}
                <div className="loader-status">
                    {progress < 99 ? 'Loading...' : progress < 100 ? 'Preparing...' : 'Ready!'}
                </div>

                {/* Floating donuts */}
                <div className="loader-donut donut-1"></div>
                <div className="loader-donut donut-2"></div>
                <div className="loader-donut donut-3"></div>
            </div>
        </div>
    )
}

// Main App component
function App() {
    const [loaded, setLoaded] = useState(false)

    return (
        <>
            <Loader onLoaded={() => setLoaded(true)} />
            <div className={`canvas-container ${loaded ? 'visible' : ''}`}>
                <Canvas
                    camera={{
                        fov: 45,
                        near: 0.1,
                        far: 200,
                        position: [-2, -2, 5]
                    }}
                >
                    <Suspense fallback={null}>
                        <Experience />
                    </Suspense>
                </Canvas>
            </div>
        </>
    )
}

const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<App />)